export default __webpack_public_path__ + "assets/images/d290ce43f120ff1f67efce9727f9dfb3.svg";